<div class="default_list">
    <ul>
        <li class="dl_li" *ngFor="let file of files">
            <core-files-list-item
                [file]="file"
                [menu]="menu"
                (actionClick)="actionClick.emit($event)"
                (menuClick)="menuClick.emit($event)"
                (iconDownloadClick)="iconDownloadClick.emit($event)"
            ></core-files-list-item>
        </li>
    </ul>
</div>
